

const process_pay_frequency = freq => {
  if (!freq) {
    return freq;
  }
  freq = freq.trim();
  if (freq === "0") {
    return "At Maturity";
  } else if (freq === "1") {
    return "Yearly";
  } else if (freq === "2") {
    return "Semi-Annually";
  } else if (freq === "4") {
    return "Quarterly";
  } else if (freq === "12") {
    return "Monthly";
  }
  return freq;
};

export { process_pay_frequency };
